<template>
    <div class="digitalToolTask">
            <el-button type="primary" @click="isShowSearchCondition=true">查询</el-button>
                <el-form v-if="isShowSearchCondition" :inline="true" class="demo-form-inline">
                    <el-row>
                    <el-form-item label="流程名称">
                        <!-- <el-input style="width: 140px;" @click.native="chooseProcess" v-model="searchParams.processInstanceName" ></el-input> -->
                        <el-select
                            style="width: 130px;"
                            v-model="searchParams.processInstanceId"
                            filterable
                            remote
                            clearable
                            reserve-keyword
                            placeholder="请输入名称"
                            :remote-method="queryProcessList"
                            :loading="processNameLoading" 
                            @change="selectProcessNameTrigger">
                            <el-option
                                v-for="item in processList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="流程模板">
                        <el-select style="width: 125px;" filterable clearable v-model="searchParams.processServiceId" @change="handleSearch"  placeholder="请选择">
                            <el-option
                                v-for="item in processTemplateList"
                                :key="item.key"
                                :label="item.templateName"
                                :value="item.processServiceId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="任务名称">
                        <el-input style="width: 100px;" @change="handleSearch" maxlength="100" v-model.trim="searchParams.taskName" placeholder="名称">
                        </el-input>
                    </el-form-item>
                    <el-form-item v-if="role==''" label="任务角色">
                        <el-select style="width: 120px;" @change="handleSearch"  v-model="searchParams.assignment" clearable placeholder="请选择">
                            <el-option
                                v-for="item in taskAssignment"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                        <el-form-item label="任务状态">
                        <el-select style="width: 200px;" @change="handleSearch"   v-model="searchParams.state" clearable placeholder="请选择">
                            <el-option
                                v-for="item in taskStateList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="子流程">
                        <el-select style="width: 80px;" @change="handleSearch" v-model="searchParams.hasTaskSubProcess" placeholder="请选择">
                            <el-option
                                v-for="item in processTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                            <el-select style="width: 80px;" @change="handleSearch" v-model="searchParams.hasApproval" placeholder="请选择">
                            <el-option
                                v-for="item in approvalTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                    <!-- <el-form-item label="上级流程">
                        <el-input style="width: 100px;" @change="handleSearch" maxlength="100" v-model.trim="searchParams.relationProcessInstanceName" placeholder="名称">
                        </el-input>
                        <el-button type="primary" icon="el-icon-search" circle @click="handleSearch"></el-button>
                    </el-form-item> -->
                </el-row>
            </el-form>
            <el-table :data="instancesListTemp" :height="tableHeight" :style="tableStyle" v-loading="loading" border  stripe>
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="name" label="任务名称"  :show-overflow-tooltip="true" >
                    <template slot-scope="scope">
                    【{{scope.row.created }}】{{scope.row.name }}
                    </template>
                </el-table-column>
                <el-table-column prop="taskInstanceDurationTime" label="任务耗时" :show-overflow-tooltip="true" ></el-table-column>
                <!-- <el-table-column prop="relationProcessInstanceName" label="上级流程" :show-overflow-tooltip="true" width="100"></el-table-column> -->
                <el-table-column prop="processInstanceName" label="所在主流程"  :show-overflow-tooltip="true" >
                    <!-- <template slot-scope="scope">
                        <el-tag  style="cursor:pointer;" type="primary" @click="linkToProcessDetail(scope.row)" size="small">{{ scope.row.processInstanceName}}</el-tag>
                    </template> -->
                </el-table-column>
                <!-- <el-table-column prop="templateName"  sortable :show-overflow-tooltip="true" label="流程模板" width="150"></el-table-column>  -->
                <!-- <el-table-column prop="processServiceName" label="流程方案" :show-overflow-tooltip="true"  width="120"></el-table-column> -->
                <!-- <el-table-column prop="assignee.trueName" label="任务负责人" width="90"></el-table-column> -->
                <!-- <el-table-column prop="created" label="任务开始时间" sortable width="150"></el-table-column> -->
                
                <!-- <el-table-column   width="70" prop="executor.candidateUsersName" label="候选人" ></el-table-column>
                <el-table-column   width="70" prop="executor.participantUsersName" label="参与人" ></el-table-column>
                
                <el-table-column  width="80"  label="任务类型" >
                        <template slot-scope="scope">
                        <el-tag type="danger" v-if="scope.row.executor.modeType === 2" >会签</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.executor.modeType === 99" >子流程</el-tag>
                        <template  v-else >常规</template>
                    </template>
                    </el-table-column> -->
                <!-- <el-table-column label="业务流" :show-overflow-tooltip="true" width="60">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.hasTaskSubProcess === '1' " type="danger" size="small">含</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="审批流" :show-overflow-tooltip="true" width="60">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.hasApproval === '1' " type="danger" size="small">含</el-tag>
                    </template>
                </el-table-column> -->
                <!-- taskStatus// 任务详细状态 0未开始 1未分配 2待认领 3进行中 4快到期 5已完成 6已延期 -->
                    <el-table-column  prop="taskStatus" label="任务状态" >
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.taskState === 3" type="unassigned" size="mini">未分配</el-tag>
                        <el-tag v-if="scope.row.taskState === 4" type="unclaimed" size="mini">待认领</el-tag>
                        <el-tag v-if="scope.row.taskState === 1" type="primary" size="mini">进行中</el-tag>
                        <el-tag v-if="scope.row.taskState === 6" type="warning" size="mini">快到期</el-tag>
                        <el-tag v-if="scope.row.taskState === 2" type="success" size="mini">已完成</el-tag>
                        <el-tag v-if="scope.row.taskState === 5" type="danger" size="mini">已延期</el-tag>
                    </template>
                </el-table-column> 
                <!-- <el-table-column  label="操作">
                    <template slot-scope="scope">
                        <el-button icon="el-icon-setting"  title="详细设置" @click="handleViewTaskDetail(scope.row)" circle></el-button>
                    </template>
                </el-table-column> -->
            </el-table>
    </div>
</template>

<script>
    import { isEmpty } from 'lodash';
    import { processTaskHidden, getProcessInstancesDetail, getProcessTaskList, getProcessInstancesList, getProcessTaskDetail, getProcessTemplateList, processTaskRevoke, processTaskClaim, processTaskTemporarySave, processTaskComplete, processTaskDelete, transferAssignee, getSerialNumber } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import TaskDetail from '@/pages/process/MyTask/TaskDetail';

    export default {
        mixins: [ mixinsNav ],
        components: {
            TaskDetail
        },
        data () {
            return {
                isShowSearchCondition: false,
                isShowProcessListDialog: false,
                processStartedBy: '', // 默认全部1我发起2我参与
                currentCnt: 0,
                instancesListTempCnt: 0,
                instancesListTemp: [], // 临时列表
                instancesList: [], // 列表数据
                loading: false, // 列表的loading状态
                searchKeyWord: '', // 查询的关键字,
                processInstanceId: '', // 流程实例ID
                instancesInfo: {},
                isFinish: false,
                isCancel: false,
                isShowProcessDetail: false,
                isShowTaskDetailDrawer: false,
                direction: 'rtl',
                isShowDiagram: false,
                taskList: [],
                isShowSetting: false,
                isReloadProcess: false,
                loadTimer: '',
                currentUserId: '',
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 100000, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                currentProcessInstanceId: '',
                isShowProcessRelate: false,
                isShowReportRelateTree: false,
                searchParams: {
                    hasTaskSubProcess: '', // 任务下含子流程实例 默认全部'',不含有0 含有1
                    hasApproval: '', // 任务下含审批流实例 默认全部'' ,不含有0 含有1
                    saveQuey: '', // 记住查询条件：1记录2清除
                    processInstanceName: '',
                    relationProcessInstanceName: '', // 上级流程名称
                    taskName: '',
                    processServiceId: '',
                    state: 1, // 默认全部 任务状态 1进行中 2已完成  3 未分配 4待认领  5已延期  6快到期
                    // assignment: 'assignee' // 默认我负责的 assignee我负责 candidate我参与 candidateUnAssignee 我参与但不负责
                    assignment: null // 默认查全部 assignee我负责 candidate我参与 candidateUnAssignee 我参与但不负责
                },
                taskStateList: [
                    {
                        value: null,
                        label: '全部'
                    },
                    {
                        value: 2,
                        label: '已完成'
                    },
                    {
                        value: 1,
                        label: '进行中'
                    },
                    {
                        value: 4,
                        label: '待认领'
                    }, {
                        value: 5,
                        label: '已延期'
                    }, {
                        value: 6,
                        label: '快到期'
                    }],
                taskAssignment: [
                    {
                        value: null,
                        label: '全部'
                    },
                    {
                        value: 'assignee',
                        label: '我负责的'
                    }, {
                        value: 'candidateUnAssignee',
                        label: '我参与的'
                    }],
                processTemplateList: [],
                isShowProcessUserOrg: false,
                processStateList: [
                    {
                        value: '',
                        label: '全部'
                    },
                    {
                        value: 1,
                        label: '进行中'
                    }, {
                        value: 2,
                        label: '已完成'
                    }],
                processTypeList: [
                    {
                        value: '',
                        label: '全部'
                    },
                    {
                        value: '0',
                        label: '不含子业务流'
                    }, {
                        value: '1',
                        label: '含子业务流'
                    }],
                approvalTypeList: [
                    {
                        value: '',
                        label: '全部'
                    },
                    {
                        value: '0',
                        label: '不含子审批流'
                    }, {
                        value: '1',
                        label: '含子审批流'
                    }],
                isShowPreview: false,
                processList: [],
                processNameLoading: false,
                canViewProcessDetail: false
            };
        },
        props: {
            //  taskState: {// 默认进行中
            //      type: [String, Number],
            //      default: 1 // 流程状态 ：默认 进行中
            //  },
            tableHeight: {
                type: Number,
                default: 460
            },
            tableStyle: {
                type: String,
                default: 'width: 100%;'
            },
            hideModeSwich: {
                type: Boolean,
                default: false
            },
            isShowNewMode: {// 查询形式 false: 旧版 true：新版
                type: Boolean,
                default: false
            },
            role: {
                type: String,
                default: ''
            },
            isFromBusTab: {
                type: Boolean,
                default: false
            }
        },
        created () {
            let currentUserStr = sessionStorage.getItem('currentUserInfo');
            let currentUserInfo = JSON.parse(currentUserStr);
            this.currentUserId = currentUserInfo.userId;
            this._initPage();
            this.queryProcessList('');
        },
        methods: {
            async _initPage () {
                this._getFormData();
            },
            async _getFormData () {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                if (!isEmpty(this.role)) {
                    // console.log(this.role);
                    if (this.role === 'assignee') {
                        this.searchParams.assignment = 'assignee';
                    } else if (this.role === 'participant') {
                        this.searchParams.assignment = 'candidateUnAssignee';
                    }
                }
                //  this.searchParams.state = this.taskState;
                let formData = await getProcessTaskList(Object.assign({}, {
                }, this.searchParams));

                if (formData && formData.data) {
                    this.instancesList = formData.data;
                    this.taskNum = this.instancesList.length;
                    if (!this.isShowNewMode) {
                        this.page.totalPageNum = this.instancesList.length;
                    } else {
                        this.page.totalPageNum = formData.totalPageNum;
                    }
                    await this.initProcessTemplateList();
                    this.dealData();
                } else {
                    this.instancesList = [];
                    this.taskNum = 0;
                    this.page.totalPageNum = 0;
                    this.instancesListTemp = [];
                }
                loading.close();
            },
            handleSearch () {
                // console.log(this.searchParams);
                this._getFormData();
            },
            queryTableData (currentPage) {
                this.page.currentPage = currentPage;
                this.dealData();
            },
            async  handleViewTaskDetail (row) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.taskInfo = await getProcessTaskDetail(row.id);
                loading.close();
                this.isCancel = false;
                this.loadTimer = new Date().getTime();
                // console.log('handleViewTaskDetail', this.isShowNewMode);
                if (this.isShowNewMode) {
                    this.isShowTaskDetailDrawer = true;
                } else {
                    this.isShowTaskDetail = true;
                }
            },
            handleModeSwich () {
                this.$emit('handleModeSwich', 'block');
            },
            async handelShowDiagram (instances) {
                // console.log(instances);
                this.instancesInfo = instances;
                await this.setProcessViewInfo(instances);
                this.loadTimer = new Date().getTime();
                this.isShowDiagram = true;
                setTimeout(() => {
                    // 调用子组件的方法
                    this.$refs.diagrams.setProcessState(this.isFinish);
                    this.$refs.diagrams.resetDiagramUrl();
                }, 0);
            },
            handleSizeChange (val) {
                this.page.pageSize = val;
                this.dealData();
            },
            dealData () {
                // 分页操作，每次取当前页*每页显示的条数再加每页显示的条数
                let cpage = (this.page.currentPage - 1) * this.page.pageSize;
                let count = this.page.pageSize + cpage;
                this.instancesListTemp = this.instancesList.slice(cpage, count);
            },
            async handelShowProcessRelate (row) {
                this.loadTimer = new Date().getTime();
                this.currentProcessInstanceId = row.id;
                setTimeout(() => {
                    this.$refs.processRelateTree._initPage();
                }, 0);
                this.isShowProcessRelate = true;
            },
            chooseProcessAssigneeUser () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.processUserOrgPop._initPage();
                }, 0);
                this.isShowProcessUserOrg = true;
            },
            processAssigneeSelectTrigger (selected) { // 流程负责人
                this.selectedProcessUser = selected;
                this.searchParams.assigneeUserId = selected.selectedUserIds;
                this.handleSearch();
                this.loadTimer = new Date().getTime();
            },
            chooseProcessStartedUser () {
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.startedUserOrgPop._initPage();
                }, 0);
                this.isShowStartedUserOrg = true;
            },
            processStartedUserSelectTrigger (selected) { // 流程发起人
                this.selectedStartedUser = selected;
                this.searchParams.startedByUserId = selected.selectedUserIds;
                this.handleSearch();
                this.loadTimer = new Date().getTime();
            },
            async initProcessTemplateList () {
                let latestData = await getProcessTemplateList({ state: 1, currentPage: 0, pageSize: 500 });// 查出最新版本的流程方案
                if (latestData) {
                    this.processTemplateList = latestData.data;
                }
            },
            async processRecordView (row) {
                this.loadTimer = new Date().getTime();
                this.instancesInfo = row;
                this.currentProcessInstanceId = this.instancesInfo.id;
                // console.log("当前流程实例ID"+this.currentProcessInstanceId);
                setTimeout(() => {
                    // 调用子组件的方法
                    this.$refs.processAdjList._initPage();
                }, 0);
                this.isShowPreview = true;
            },
            async handleTaskClaim (params) {
                let { taskId } = params;
                await processTaskClaim(taskId);
                this.isShowTaskDetailDrawer = false;
                this.refreshTaskDetail(taskId);
            },
            async handleTaskComplete (taskData) {
                // console.log(this.taskInfo);
                console.log(this.taskInfo.taskDefinitionKey);
                let task = {
                    taskDefinitionKey: this.taskInfo.taskDefinitionKey,
                    processInstanceId: this.taskInfo.processInstanceId,
                    processServiceId: this.taskInfo.processServiceId,
                    deploymentId: this.taskInfo.processDefinitionDeploymentId,
                    taskId: this.taskInfo.id,
                    operateType: taskData.operateType,
                    btnConditions: taskData.btnConditions,
                    operateOpinion: taskData.operateOpinion,
                    forms: taskData.forms,
                    modelInstanceIds: taskData.modelInstanceIds,
                    isApproval: this.taskInfo.taskNode.isApproval,
                    canUnStartApproval: this.taskInfo.taskNode.canUnStartApproval,
                    isSubProcess: this.taskInfo.taskNode.isSubProcess,
                    needAllSubProcess: this.taskInfo.taskNode.needAllSubProcess,
                    mainModelInfo: taskData.mainModelInfo,
                    operateName: taskData.operateName,
                    mainDataModelInstanceIds: taskData.mainDataModelInstanceIds
                };
                let loading;
                try {
                    loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    if (this.taskInfo.formObj) {
                        await this.renderSerialNumber(this.taskInfo.formObj.structure, task.forms, taskData.operateType);
                    }
                    await processTaskComplete(task);
                    loading.close();
                    this.isShowTaskDetailDrawer = false;
                    await this._getFormData();
                } catch (error) {
                    console.error('任务保存出错：' + error);
                    loading.close();
                }
                // console.log(task);
            },
            async handleTaskDelete () {
                // console.log(task);
                this.$confirm(`您确定要删除任务吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await processTaskDelete(this.taskInfo.processInstanceId, this.taskInfo.id);
                    loading.close();
                    this.isShowTaskDetailDrawer = false;
                    await this._getFormData();
                }).catch(() => {});
            },
            async handleTaskHidden () {
                // console.log(task);
                this.$confirm(`您确定要隐藏该任务吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    await processTaskHidden({processInstanceId: this.taskInfo.processInstanceId, taskInstanceId: this.taskInfo.id});
                    loading.close();
                    this.isShowTaskDetailDrawer = false;
                    await this._getFormData();
                }).catch(() => {});
            },
            async handleTaskTemporarySave (taskData) {
                console.log(this.taskInfo.taskDefinitionKey);
                let task = {
                    taskDefinitionKey: this.taskInfo.taskDefinitionKey,
                    processInstanceId: this.taskInfo.processInstanceId,
                    processServiceId: this.taskInfo.processServiceId,
                    deploymentId: this.taskInfo.processDefinitionDeploymentId,
                    taskId: this.taskInfo.id,
                    forms: taskData.forms,
                    btnConditions: taskData.btnConditions,
                    modelInstanceIds: taskData.modelInstanceIds,
                    operateOpinion: taskData.operateOpinion,
                    mainModelInfo: taskData.mainModelInfo
                };
                // console.log(JSON.stringify(task, null, 2));
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    await this.renderSerialNumber(this.taskInfo.formObj.structure, task.forms, '1');// 1:代表完成，暂存于完成生成流水号规则一致
                    await processTaskTemporarySave(task);
                    loading.close();
                    await this.refreshTaskDetail(this.taskInfo.id);
                } catch (error) {
                    console.log(error);
                } finally {
                    loading.close();
                }
            },
            async renderSerialNumber (forms, formData, operateType) {
                if (forms && formData && forms.length > 0 && formData.length > 0) {
                    for (var dIndex = 0; dIndex < formData.length; dIndex++) {
                        // if (formData[dIndex].values.id) {
                        //     continue;
                        // }
                        let fData = formData[dIndex];
                        for (var findex = 0; findex < forms.length; findex++) {
                            let formInfo = forms[findex];
                            // 流水号保存生成字段渲染
                            if (fData.formId === formInfo.id && formInfo.fieldsList && formInfo.fieldsList.length > 0) {
                                for (var fieldIndex = 0; fieldIndex < formInfo.fieldsList.length; fieldIndex++) {
                                    let field = formInfo.fieldsList[fieldIndex];
                                    // 假如是流水号字段并且流水号有值的情况下就不走流水号生成逻辑了
                                    if (field.type === 'serialNumber' && !isEmpty(fData.values[field.id])) {
                                        console.log(field.name + '---------' + field.type);
                                        console.log(fData.values[field.id]);
                                        continue;
                                    }
                                    if (field.type === 'subform' && fData.values[field.id] && fData.values[field.id].length > 0) {
                                        for (var dataIndex = 0; dataIndex < fData.values[field.id].length; dataIndex++) {
                                            var subData = fData.values[field.id][dataIndex];
                                            for (var subFieldIndex = 0; subFieldIndex < field.options.fieldList.length; subFieldIndex++) {
                                                let subField = field.options.fieldList[subFieldIndex];
                                                if (subField.type === 'serialNumber' && subField.options.ext3 === '2' && !formData[dIndex].values.id && subField.options.config.options.length > 0 && !subData[subField.id]) {
                                                    await this.setSerialNumber(subField.options.config.options[0].value, subField, subData);
                                                } else if (subField.type === 'serialNumber' && subField.options.ext3 === '4' && operateType === '2' && !subField.isRead && subField.options.config.options.length > 0 && !subData[subField.id]) {
                                                    await this.setSerialNumber(subField.options.config.options[0].value, subField, subData);
                                                } else if (field.type === 'serialNumber' && field.options.ext3 === '6') { // 根据字段值进行生成流水号
                                                    let ext2Obj = JSON.parse(subField.options.ext2);
                                                    let curFieldValue = fData.values[ext2Obj.seriaNumberGenerateFieldId];
                                                    if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue) {
                                                        await this.setSerialNumber(subField.options.config.options[0].value, subField, subData);
                                                    }
                                                } else if (field.type === 'serialNumber') { // 多规则的流水号生成规则
                                                    let ext2 = field.options.ext2;
                                                    if (ext2) {
                                                        let ext2Obj = JSON.parse(ext2);
                                                        if (ext2Obj.moreSerialNumber) { // 多规则配置
                                                            let serialNumberRuleList = ext2Obj.serialNumberRuleList;
                                                            for (let i = 0; i < serialNumberRuleList.length; i++) {
                                                                let element = serialNumberRuleList[i];
                                                                let takeEffectField = element.takeEffectField;
                                                                let takeEffectFieldValue = element.takeEffectFieldValue;
                                                                let formFieldVal = formData.values[takeEffectField];
                                                                if (takeEffectFieldValue.indexOf(formFieldVal) !== -1) { // 满足条件了
                                                                    if (element.seriaNumberDepartTypeFormFieldId) {
                                                                        ext2Obj.seriaNumberDepartTypeFormFieldId = element.seriaNumberDepartTypeFormFieldId;
                                                                    }
                                                                    if (element.seriaNumberDepartTypeFormFieldIdValue) {
                                                                        ext2Obj.seriaNumberDepartTypeFormFieldIdValue = element.seriaNumberDepartTypeFormFieldIdValue;
                                                                    }
                                                                    if (element.seriaNumberSelectTypeFormFieldId) {
                                                                        ext2Obj.seriaNumberSelectTypeFormFieldId = element.seriaNumberSelectTypeFormFieldId;
                                                                    }
                                                                    field.options.ext2 = JSON.stringify(ext2Obj);
                                                                    await this.setSerialNumber(element.selectedNode.id, subField, subData, formInfo);
                                                                    break;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        // field.type === 'serialNumber' 审批流字段
                                        // field.options.ext3,'2'：保存后生成，4：审批后生成
                                        // operateType，1:完成（即保存），2：同意/通过（即审批通过）
                                        // field.isRead,true（disabled）：不可编辑，其他（false/null），可编辑
                                        // fData.values[field.formField],判断此字段是否已存在
                                    } else if (field.type === 'serialNumber' && field.options.ext3 === '2' && !formData[dIndex].values.id && field.options.config.options.length > 0 && !fData.values[field.formField]) {
                                        await this.setSerialNumber(field.options.config.options[0].value, field, fData.values);
                                    } else if (field.type === 'serialNumber' && field.options.ext3 === '4' && operateType === '2' && !field.isRead && field.options.config.options.length > 0 && !fData.values[field.formField]) {
                                        await this.setSerialNumber(field.options.config.options[0].value, field, fData.values);
                                    } else if (field.type === 'serialNumber' && field.options.ext3 === '6') { // 根据字段值进行生成流水号
                                        let ext2Obj = JSON.parse(field.options.ext2);
                                        let curFieldValue = fData.values[ext2Obj.seriaNumberGenerateFieldId];
                                        if (ext2Obj.seriaNumberGenerateFieldIdValue && typeof (ext2Obj.seriaNumberGenerateFieldIdValue) === 'object') {
                                            for (let i = 0; i < ext2Obj.seriaNumberGenerateFieldIdValue.length; i++) {
                                                if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue[i]) {
                                                    await this.setSerialNumber(field.options.config.options[0].value, field, fData.values, formInfo);
                                                }
                                            }
                                        } else {
                                            if (curFieldValue === ext2Obj.seriaNumberGenerateFieldIdValue) {
                                                await this.setSerialNumber(field.options.config.options[0].value, field, fData.values, formInfo);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            async setSerialNumber (sid, field, formData) {
                if (sid) {
                    let numberObj = await getSerialNumber(sid);
                    if (numberObj) {
                        formData[field.formField] = numberObj.newSerialNumber;
                        formData[field.formField + '-sn'] = numberObj.sn;
                    }
                }
            },
            async handleTaskRevoke () {
                this.$confirm(`您确定要回退任务吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    let task = {
                        processInstanceId: this.taskInfo.processInstanceId,
                        processServiceId: this.taskInfo.processServiceId,
                        deploymentId: this.taskInfo.processDefinitionDeploymentId,
                        taskId: this.taskInfo.id
                    };
                    let loading;
                    try {
                        loading = this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        await processTaskRevoke(task);
                        loading.close();
                        this.isShowTaskDetailDrawer = false;
                        await this._getFormData();
                    } catch (error) {
                        console.error('任务回退出错：' + error);
                        loading.close();
                    }
                }).catch(() => {});
            },
            async transferTask (param) {
                this.$confirm(`您确定要转办任务吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    await transferAssignee(param);
                    await this._getFormData();
                }).catch(() => {});
            },
            setShowleftList (isShowLeft) {
                this.isShowLeft = isShowLeft;
            },
            chooseProcess () {
                this.isShowProcessListDialog = true;
            },
            selectTrigger (selected) { // 选择流程
                this.searchParams.processInstanceId = selected.id;
                this.searchParams.processInstanceName = selected.label;
            },
            async handleClickOk () {
                this.isShowProcessListDialog = false;
                // 选完流程名后，自定查询
                this.handleSearch();
            },
            navToBusiniessProcessTab () {
                this.$emit('navToBusiniessProcessTab');
            },
            refreshTaskDetail () {
                this._getFormData();
            },
            selectProcessNameTrigger (id) { // 选择流程
                let selected = {id: '', label: ''};
                if (id) {
                    selected = this.processList.find((item) => {
                        return item.id === id;
                    });
                }
                this.searchParams.processInstanceName = selected.name;
                this.handleSearch();
            },
            async queryProcessList (name) {
                this.processNameLoading = true;
                let processInstances = await getProcessInstancesList({
                    pageSize: 1000,
                    currentPage: 1,
                    serviceName: name
                    // state: this.processState
                });
                if (processInstances && processInstances.data) {
                    this.processList = processInstances.data;
                }
                this.processNameLoading = false;
            },
            async linkToProcessDetail (row) {
                // console.log(row);
                if (this.canViewProcessDetail) {
                    // console.log(this.isNewPage);
                    this.instances = await getProcessInstancesDetail(row.processInstanceId);
                    // 流程实例ID，流程实例名称，流程实例状态
                    let processInstanceStr = {};
                    processInstanceStr.processInstanceId = this.instances.id;
                    processInstanceStr.processInstanceName = this.instances.name;
                    processInstanceStr.finish = this.instances.finish;
                    let processInstanceJson = JSON.stringify(processInstanceStr);
                    sessionStorage.setItem('navToProcessList', processInstanceJson);
                    if (this.isFromBusTab) { // 来源于新版的应用tab
                        this.navToBusiniessProcessTab();
                    } else {
                        let currentUserStr = sessionStorage.getItem('currentUserInfo');
                        let currentUserInfo = JSON.parse(currentUserStr);
                        if (this.instances.startedBy.id === currentUserInfo.userId) {
                            this.navMyProcessmyProcessStartedBy();
                        } else {
                            this.navMyProcessMyProcessParticipant();
                        }
                    }
                } else {
                    //  this.messageTip('您无流程权限，无法查看流程详情！', 'warning');
                }
            },
            messageTip (msg, type) {
                this.$message({
                    message: msg,
                    type: type,
                    duration: 3000
                });
            }
        }
    };
</script>

<style lang="less">
    .digitalToolTask {
        height: 100%;
        width: 100%;
        margin-top: -14px;
        .tools-bar {
            position:fixed;
            width:100%;
            height:auto;
            overflow-y:auto;
            min-height: 40px;
            justify-content: flex-start;
        }
        .table-main {
            // height:540px;
            overflow-y:auto;
        }
    }
    .business-report-tree{
        .process-report-dialog{
            .el-dialog__body{
                height: ~'calc(100% - 10vh)';
                margin-top: -2vh;
                padding: 20px 20px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DigitalTool/DigitalToolTask.vue